import { getCSRFToken, getHttpResponse } from "@/components/shared/lib/utils";
import { PlayerPublish } from "./types";

export async function getPlayers(url = "/dash/players/all_players") {
  const res = await getHttpResponse("GET", url ); 
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const error = new Error("Failed to get players") as Error & { details?: string[]; status?: number };
    error.details = data?.errors || [res.statusText];
    throw error;
  }

  return data;
}

export async function publishPlayers(playerIds: string[]) {
  const res = await getHttpResponse("POST", "/dash/players/publish", { ids: playerIds });
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const error = new Error("Failed to publish players") as Error & { details?: string[]; status?: number };
    error.details = data?.errors || [res.statusText];
    throw error;
  }

  return data;
}

export function mapPlayersToPublish(data: any): PlayerPublish[] {
  return (Array.isArray(data) ? data : (data?.players ?? []))
    .map((p: any): PlayerPublish => ({
      id: String(p.id),
      name: p.name,
      location: p.contact_name || p.ip_address || "Unknown",
      status: p.offline === true ? "offline" : p.online === "warning" ? "warning" : "online",
      deviceType: p.player_model_name ?? undefined,
    }));
}